import * as React from "react";

const ChevronSmallRight: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.50289 8.50301C9.11237 8.11248 9.11237 7.39353 9.50289 7.00301C9.89342 6.61248 10.6124 6.61248 11.0029 7.00301L16.0029 12.003L11.0029 17.003C10.6124 17.3935 9.89342 17.3935 9.50289 17.003C9.11237 16.6125 9.11237 15.8935 9.50289 15.503L13 12.003L9.50289 8.50301Z" fill="currentColor"/>
        </svg>
    );
};

export default React.memo(ChevronSmallRight);
